import React from 'react';
import IntlMessages from 'util/IntlMessages';
import {connect} from 'react-redux'
import {userSignOut} from 'actions/Auth';
import config from '../../config';

class UserInfoPopup extends React.Component {
  render() {
    return (
      <div>
        <div className="user-profile">
          <img className="user-avatar border-0 size-40 rounded-circle"
               src={config.userAuthApiUrl + this.props.user.profileImageUrl}
               alt="User"/>
          <div className="user-detail ml-2">
            <h4 className="user-name mb-0">{this.props.userName}</h4>
            <small>Administrator</small>
          </div>
        </div>
        <span className="jr-link dropdown-item text-muted">
          <i className="zmdi zmdi-face zmdi-hc-fw mr-1"/>
          <IntlMessages id="popup.profile"/>
        </span>
        <span className="jr-link dropdown-item text-muted">
          <i className="zmdi zmdi-settings zmdi-hc-fw mr-1"/>
          <IntlMessages id="popup.setting"/>
        </span>
        <span className="jr-link dropdown-item text-muted" onClick={() => this.props.userSignOut()
        }>
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1"/>
          <IntlMessages id="popup.logout"/>
        </span>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const locale = state.settings.locale;
  const userName = state.auth.authUser.name + ' '+state.auth.authUser.surname;
  const user = state.auth.authUser;
  return {locale , userName ,user}
};
export default connect(mapStateToProps, {userSignOut})(UserInfoPopup);


